import { Routes } from '@angular/router';
import { AuthGuard } from '../modules/auth/_guards/auth.guard';
import { MainComponent } from "./main/main.component";
import { HomeComponent } from "./home/home.component";
import { SettingsComponent } from "./settings/settings.component";
import { RouterPaths } from "../config/router-paths.model";
import { SupportComponent } from "./support/support.component";
var ɵ0 = function () { return import("./terms-and-conditions/terms-and-conditions.module.ngfactory").then(function (m) { return m.TermsAndConditionsModuleNgFactory; }); };
var routes = [
    {
        path: '', component: MainComponent, children: [
            { path: RouterPaths.home, component: HomeComponent },
            { path: RouterPaths.termsAndConditions, loadChildren: ɵ0 },
            { path: RouterPaths.settings, component: SettingsComponent, canActivate: [AuthGuard] },
            { path: RouterPaths.support, component: SupportComponent, canActivate: [AuthGuard] },
            { path: '**', redirectTo: '', pathMatch: 'full' }
        ]
    }
];
var PagesModule = /** @class */ (function () {
    function PagesModule() {
    }
    return PagesModule;
}());
export { PagesModule };
export { ɵ0 };
